import { AsyncPipe, CurrencyPipe, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, Input, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NumericInputHelperUtil } from '@zero/shared/util-helper';
import { Asset } from '@zero/shared/util-models';
import { MultiOrderInstrument, TradeFacade } from '@zero/trade/domain';
import { MultiOrderEstimatedSumComponent } from '../multi-order-estimated-sum/multi-order-estimated-sum.component';
import { MultiOrderInstrumentSearchComponent } from '../multi-order-instrument-search/multi-order-instrument-search.component';
import { MultiOrderNoticeComponent } from '../multi-order-notice/multi-order-notice.component';

@Component({
  selector: 'trade-multi-order-create-buy-list',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslocoPipe,
    AsyncPipe,
    FormsModule,
    CurrencyPipe,
    MultiOrderEstimatedSumComponent,
    NgTemplateOutlet,
    MultiOrderNoticeComponent,
  ],
  templateUrl: './multi-order-create-buy-list.component.html',
  styleUrl: '../../styles/multi-order-list.scss',
})
export class MultiOrderCreateBuyListComponent {
  @Input() public instruments: MultiOrderInstrument[];

  public readonly facade = inject(TradeFacade);
  readonly #modal = inject(NgbModal);
  readonly #destroyRef = inject(DestroyRef);

  public addToBuyList() {
    const ref = this.#modal.open(MultiOrderInstrumentSearchComponent);
    ref.componentInstance.currentInstruments = this.instruments;
    ref.componentInstance.assetPicked
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe((asset: Asset) => this.facade.addMultiOrderInstrument({ isin: asset.isin, direction: 'buy', asset }));
  }

  public handleWheel = (ev: Event): void => NumericInputHelperUtil.handleWheel(ev);
}
